import { render, staticRenderFns } from "./RelationChain.vue?vue&type=template&id=a979a8e2&scoped=true"
import script from "./RelationChain.vue?vue&type=script&lang=js"
export * from "./RelationChain.vue?vue&type=script&lang=js"
import style0 from "./RelationChain.vue?vue&type=style&index=0&id=a979a8e2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a979a8e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a979a8e2')) {
      api.createRecord('a979a8e2', component.options)
    } else {
      api.reload('a979a8e2', component.options)
    }
    module.hot.accept("./RelationChain.vue?vue&type=template&id=a979a8e2&scoped=true", function () {
      api.rerender('a979a8e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/userDetails/components/RelationChain.vue"
export default component.exports